import authReducer from './authReducer'
import projectReducer from './projectReducer'
import{combineReducers} from 'redux'
import {firestoreReducer} from 'redux-firestore'
import {firebaseReducer} from 'react-redux-firebase'


const rootReducer = combineReducers ({
    auth: authReducer,
    project: projectReducer,
    firestore: firestoreReducer,  // Add store to reducers
    firebase: firebaseReducer //Sync our Auth status 
});

export default rootReducer